export default () => {
  const token = localStorage.getItem('access_token');

  // return authorization header
  if (token) return { Authorization: `Bearer ${token}` };

  return {};
};
